import {
    forEach as _forEach,
} from '@lodash';
import { mapActions, mapGetters } from 'vuex';
import { errorGuard } from '@app/utils';
import config from '@config';
import { routeNames } from '@app/router';
import ValidationError from '@core/errors/network/ValidationError';
import ClientStorage from '@core/utils/storage/ClientStorage';
import { UTM_DATA } from '@app/analytics/utm';
import {
    isRequired,
    minLength,
    checkValidCharacters,
} from '@modules/shared/validators/forms';
import { authenticationService } from '@core/services/authentication/AuthenticationService';

export default {
    created() {
        (this as any).config = config;
    },
    data() {
        return {
            fields: {
                email: {
                    value: '',
                    validate: [
                        isRequired,
                    ],
                    asyncValidate: authenticationService.isRegisterFieldValid.bind(authenticationService),
                },
                username: {
                    value: '',
                    validate: [
                        isRequired,
                        minLength(6),
                        checkValidCharacters(config.countrySpecific.auth.usernameValidChars)
                    ],
                    asyncValidate: authenticationService.isRegisterFieldValid.bind(authenticationService),
                },
                password: {
                    value: '',
                    validate: [
                        isRequired,
                    ],
                    asyncValidate: authenticationService.isRegisterFieldValid.bind(authenticationService),
                },
                firstName: {
                    value: '',
                    validate: [
                        isRequired,
                        minLength(2)
                    ]
                },
                lastName: {
                    value: '',
                    validate: [
                        isRequired,
                        minLength(2)
                    ]
                },
                termsAgree: {
                    value: false,
                    validate: [
                        isRequired,
                    ]
                },
            },
            validationErrorsPattern: /#.+?REGFIELD /gi,
            isLoading: false,
            isRegistered: false,
            asyncErrors: {},
            asyncFieldError: {}
        };
    },
    watch: {
        user(newValue: any) {
            if (newValue) {
                (this as any).$router.replace({
                    name: routeNames.landing,
                });
            }
        },
    },
    computed: {
        ...mapGetters('data/authentication', [
            'user',
        ]),
    },
    methods: {
        ...mapActions('ui/help', [
            'showHelp',
        ]),
        ...mapActions('data/authentication', [
            'register',
        ]),
        ...mapActions('errors', [
            'showError',
        ]),
        async onRegisterClick() {
            // tslint:disable-next-line:no-this-assignment
            const self: any = this;
            self.asyncErrors = {};
            self.isLoading = true;
            await errorGuard({
                action: async () => {
                    const data = self.createRegisterInput();
                    this.beforeSubmit(data);
                    await self.register(data);
                    self.isRegistered = true;
                    ClientStorage.remove(UTM_DATA);
                    self.scrollToTop();
                },
                onError: (e: Error) => {
                    if (e instanceof ValidationError) {
                        _forEach(e.fieldErrors, (value, key) => {
                            e.fieldErrors[key] = value
                                .map((item) => item.replace(self.validationErrorsPattern, ''));
                        });
                        self.asyncErrors = e.fieldErrors;
                    } else {
                        self.showError(e);
                    }
                },
            });
            self.isLoading = false;
        },
        createRegisterInput() {
            const self = this as any;
            const result: any = {};
            Object.keys(self.fields).forEach((key) => {
                const value = self.fields[key].value;
                if (typeof value === 'boolean' && !value) {
                    return;
                }
                result[key] = value;
            });
            return {
                ...result,
                ...ClientStorage.get(UTM_DATA)
            };
        },
        beforeSubmit(result: any) {
            // child will add any additional inputs
        },
        onInput(field: any, value: any) {
            (this as any)[field] = value;
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/authentication/mixins/RegisterMixin.ts